import { useMemo } from 'react';
import Menuitems from '../layouts/full/vertical/sidebar/MenuItems';

/**
 * Custom hook to check page availability and handle redirection logic
 */
export const usePageAvailability = () => {
  // Get menu items using the hook at the top level
  const menuItems = Menuitems();

  // Memoize the flattened menu items
  const flattenedMenuItems = useMemo(() => {
    return menuItems
      .filter((item: any) => !item._name) // Remove spacers and dividers
      .flatMap((item: any) => {
        if (item.children && item.children.length > 0) {
          // Return all children if parent has children
          return item.children;
        }
        // Return the parent item if no children
        return [item];
      });
  }, [menuItems]);

  // Function to check if a page is available for a scan package
  const isPageAvailableForScanPackage = (currentPath: string, scanPackageName: string): boolean => {
    if (!currentPath || !scanPackageName) return true;
    
    // Find the current page's menu item
    const currentPageItem = flattenedMenuItems.find((item: any) => item.href === currentPath);
    
    // Check if current page has plan restrictions
    if (currentPageItem?.availablePlans) {
      return currentPageItem.availablePlans.includes(scanPackageName);
    }
    
    // If no availablePlans defined, page is available for all plans (no restrictions)
    return true;
  };

  // Function to get redirect path for domain change
  const getRedirectPathForDomainChange = (currentPath: string, activeDomainData: any): string | null => {
    if (!activeDomainData?.scanPackageDetail?.name) return null;
    
    const scanPackageName = activeDomainData.scanPackageDetail.name;
    const isAvailable = isPageAvailableForScanPackage(currentPath, scanPackageName);
    
    return isAvailable ? null : '/targets';
  };

  return {
    isPageAvailableForScanPackage,
    getRedirectPathForDomainChange,
  };
}; 